module.exports = __webpack_public_path__ + "img/apple-iphone-8.cf4477bf.jpg";